import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import OnewayPickupBasicRateServices from "services/OnewayPickupServices";
import { notifyError, notifySuccess } from "utils/toast";

const useOnewayPickupBasicRateSubmit = (id) => {

  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fromCity, setFromCity] = useState(null);
  const [toCity, setToCity] = useState(null);
  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState(null);
  const [dataInput, setDataInput] = useState([{ "vehicle_type_0": "", "min_rate_0": "", "min_km_0": "", "extra_km_0": "", "prime_0": "" }]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [primeAvailable, setPrimeAvailable] = useState();
  const [minKm, setMinKm] = useState("");

  const handleVehicleCategoryChange = (e, index) => {
    const { name, value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const handleFromCityChange = (city_id) => {
    setFromCity(city_id);
  };

  const handleToCityChange = (city_id) => {
    setToCity(city_id);
  };


  const handleChangeInput = (e, i) => {
    if (e && e.target) {
      const { name, value } = e.target;
      const onChangeVal = [...dataInput];
      onChangeVal[i][name] = value;
      setDataInput(onChangeVal);
    }
  };
  const onSubmit = async (data) => {
    try {
      const dataValues = {};
      const vehicleTypeValues = dataInput.map((item) => parseInt(item[Object.keys(item)[0]]));

      const MinRateValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[1]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});




      const MinKMValues = dataInput.reduce((acc, item, index) => {
        const vehicleId = item[`vehicle_type_${index}`];
        acc[vehicleId] = String(minKm || 0);
        return acc;
      }, {});


      const ExtraKMValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[3]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const PrimeValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[4]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      dataValues.vehicle_type = vehicleTypeValues;
      dataValues.min_rate = MinRateValues;
      dataValues.min_km = MinKMValues;
      dataValues.extra_km = ExtraKMValues;
      dataValues.prime = PrimeValues;
      dataValues.from_city = fromCity ? [fromCity] : [];
      dataValues.to_city = toCity ? [toCity] : [];


      setIsSubmitting(true);

      if (id) {
        const res = await OnewayPickupBasicRateServices.updateOnewayPickupBasicRate(id, dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await OnewayPickupBasicRateServices.addOnewayPickupBasicRate(dataValues);

        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      // closeDrawer();
    }
  };

  const getonewayPickupBasicRateData = async () => {
    try {
      const res = await OnewayPickupBasicRateServices.getOnewayPickupBasicRateById(id);

      if (res?.data) {
        const FormWholeArray = [];

        if (Array.isArray(res.data.vehicle_type_id)) {
          res.data.vehicle_type_id.forEach((item, index) => {
            const vehicleId = Number(item);
            let obj = {};
            obj[`vehicle_type_${index}`] = vehicleId;
            obj[`min_rate_${index}`] = res.data.min_rate?.[vehicleId] ?? "";
            obj[`min_km_${index}`] = res.data.min_km?.[vehicleId] ?? "";
            obj[`extra_km_${index}`] = res.data.extra_km?.[vehicleId] ?? "";

            FormWholeArray.push(obj);
          });
        }

        setDataInput(FormWholeArray);
        setSelectedOptions(res.data.vehicle_type_id.map(Number));
        setFromCity(res.data.from_city?.[0] ?? null);
        setToCity(res.data.to_city?.[0] ?? null);
        setPrimeAvailable(res.data.prime_available);
        if (res.data.min_km && res.data.vehicle_type_id?.length) {
          const firstVehicleId = res.data.vehicle_type_id[0];
          setMinKm(res.data.min_km[firstVehicleId] ?? "");
        }
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
    }
  };


  useEffect(() => {
    if (!isDrawerOpen) {
      setDataInput([{ "vehicle_type_0": "", "min_rate_0": "", "min_km_0": "", "extra_km_0": "" }]);   //, "prime_0": ""
      setSelectedOptions([]);
      setFromCity(null);
      setToCity(null);
      clearErrors("name_of_oneway");
      setMinKm("");
      clearErrors();

      return;
    }

    if (id) {
      getonewayPickupBasicRateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    minKm,
    setMinKm,
    register,
    handleSubmit,
    onSubmit,
    handleFromCityChange,
    handleToCityChange,
    fromCity,
    toCity,
    trigger,
    errors,
    isSubmitting,
    selectedVehicleCategory,
    setSelectedVehicleCategory,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    primeAvailable
  };
};

export default useOnewayPickupBasicRateSubmit;
